import request from '@apps-common/js-client/api/request';
import {
  PDA_ADMIN_V0_BASE_PATH,
  PDA_ADMIN_V1_BASE_PATH as base,
} from '@account/config';

const ENTERPRISE_PROGRAM_ID = 3;

export const getOrganizations = ({
  limit = 20,
  offset = 0,
  sort = 'name',
  descending = false,
  search = '',
  state = ['active'],
  parentOrgId,
}) => {
  const enterprise = state.includes('enterprise');
  const states = state.filter(s => s !== 'enterprise');
  const params = {
    limit,
    sort: `${descending ? '-' : ''}${sort}`,
    offset,
    search,
    parent_organization_id: parentOrgId,
    state__in: states,
    program_id__eq: enterprise ? ENTERPRISE_PROGRAM_ID : null,
  };

  return request.get(`/${base}/organizations/`, {params}).then(res => res.data);
};

export const createOrganization = ({name, parentOrgId = null}) => {
  const params = {
    name,
    program: {
      id: ENTERPRISE_PROGRAM_ID,
      name: 'Enterprise',
    },
    parent_organization_id: parentOrgId,
  };

  return request.post(`/${base}/organizations/`, params).then(res => res.data);
};

export const getOrganization = orgId =>
  request.get(`/${base}/organizations/${orgId}`).then(res => res.data);

export const getOrganizationAutosuggest = ({
  limit = 8,
  search = '',
  excludeSuborgs = false,
} = {}) =>
  request
    .get(`${base}/organizations/autosuggest/`, {
      params: {
        resultcount: limit,
        search,
        exclude_suborgs: !!excludeSuborgs,
      },
    })
    .then(res => res.data);

export const getOrgInvitations = orgId =>
  request
    .get(`/${PDA_ADMIN_V0_BASE_PATH}/organizations/${orgId}/invitations`)
    .then(res => res.data);

export const inviteUser = ({orgId, email, role}) =>
  request
    .post(`/${PDA_ADMIN_V0_BASE_PATH}/organizations/${orgId}/invitations`, {
      email,
      role_level: role,
    })
    .then(res => res);

export const getOrgMemberships = ({
  orgId,
  limit = 20,
  offset = 0,
  sort = 'id',
  descending = false,
  search = '',
  state = ['active'],
}) => {
  const params = {
    limit,
    sort: `${descending ? '-' : ''}${sort}`,
    offset,
    search,
    state__in: state.toString(),
  };

  return request
    .get(`/${base}/organizations/${orgId}/memberships`, {params})
    .then(res => res.data);
};

/**
 * A user's role is really on the membership as a user can have many memberships
 */
export const updateMembershipRole = ({memberId, orgId, roleLevel}) =>
  request
    .put(`${base}/organizations/${orgId}/memberships/${memberId}`, {
      role_level: roleLevel,
    })
    .then(res => res.data);

export const getOrgNicfiCta = orgId =>
  request.get(`/${base}/organizations/${orgId}/cta`).then(res => res.data);
